import { useMsal } from "@azure/msal-react";

export default function useAuthenticatedUser() {
    const { accounts } = useMsal();
    
    return accounts?.length ? accounts[0] : null;
}
